import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IVideoExport } from '@obvious.tech/constellation'

export const VideoExport = defineEntity('VideoExport', {
  endpoint: 'videomanager/api/VideoExport',
  schema: SNoop<IVideoExport>(),
})
